// extracted by mini-css-extract-plugin
export default {"main":"myFavorite_main__a4VdX","button_con":"myFavorite_button_con__nL0o8","container":"myFavorite_container__y3GO9"};